/**
 * Vue Router 路由配置
 * 结构：
 *   / → 重定向到 /layout/home
 *   /layout → Layout 布局容器（含 PC 侧边栏 / 移动端 Tabbar）
 *     /layout/home  → 首页（推荐歌单 + 最新音乐）
 *     /layout/hot   → 热门歌曲
 *     /layout/search → 搜索
 *   /play → 播放页（独立路由，不受 Layout 包裹）
 *   未匹配 → 重定向到首页
 */
import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/views/Layout'

const routes = [
  {
    path: '/',
    redirect: '/layout/home'
  },
  {
    path: '/layout',
    component: Layout,
    redirect: '/layout/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/Home')
      },
      {
        path: 'hot',
        component: () => import('@/views/Hot')
      },
      {
        path: 'search',
        component: () => import('@/views/Search')
      }
    ]
  },
  {
    path: '/play',
    component: () => import('@/views/Play')
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/layout/home'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router